<template>
  <div class="content t1 s8">跳转中。。。</div>
</template>
<script>
import api from '@/api/api'
export default {
  name: '中转空页面',
  data() {
    return {}
  },
  created() {
    api.channel.getWechatSchemaLink().then(res => {
      const { detail, result } = res
      if (result && result.code === 0) {
        location.href = detail
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 30px;
}
</style>
